import SuccessAction from '../../../../../components/successAction';
import HelmetComp from '../../../../../components/helmet/Helmet';
import { title } from '../../../../../utils/matchingTitle';

const CustomerBookingError = () => {
  const props: any = {
    title: '依頼予約は失敗しました。',
    textDescription: (
      <>
        クレジットカードの状況をご確認の上、
        <br />
        再度予約手続きをお願いいたします。
      </>
    ),
    bookingSuccess: true,
    isLogin: true,
    mail: true,
    isErrorBooking: true,
  };
  return (
    <>
      <HelmetComp user title={title.customerBookingError} />
      <SuccessAction {...props} />
    </>
  );
};

export default CustomerBookingError;
